/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SimulationType {
    Specialization = 'Specialization',
    Optional = 'Optional',
    ChangeRequest = 'ChangeRequest'
}

export function SimulationTypeFromJSON(json: any): SimulationType {
    return SimulationTypeFromJSONTyped(json, false);
}

export function SimulationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationType {
    return json as SimulationType;
}

export function SimulationTypeToJSON(value?: SimulationType | null): any {
    return value as any;
}

